import React, { Dispatch, SetStateAction } from "react";
import NextItem from "../components/NextItem";
import BackButton from "../components/BackButton";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { useMetaTags } from '../utils/useMetaTags';
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import { Wavedivider } from "../components/Wavedivider";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import YouTubeEmbed from "../components/YouTubeEmbed";
import { CalloutLink } from "../components/CalloutLink";
import { QuoteBlock } from "../components/QuoteBlock";

function Book1(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_BOOK1_PASSWORDS
      );
      
      useMetaTags({
        title: 'bookreport - Lynkim',
        description: '롤스의 정의론',
        image: '/ogimage.png',
      });
      
      return (
        <>
        {/* <ProtectedPage password={hashedPasswords} description="이번 가을에 단풍을 보러 간 곳"> */}
          <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
          <div className='fadeIn '>
            <ArticleTitle
              title={'롤스의 정의론'}
              titleEn={"Rawls's Theory of Justice"}
              description={<div>평등주의적 개인주의 관점의 정의론</div>}
              descriptionEn={<div>A theory of justice from an egalitarian individualist perspective</div>}
              category={'book report'}
              date={'2026.02.01.'}
            //   thumbnail={image2}
        />
          </div>
          <Wavedivider/>
          <div className='articleLayout'>
            <ArticleTextSection
            description= {<div>
               
                평등주의적 자유주의자인 존 롤스의 정의론에 대해 설명하고 비판하는 책이다. 존 롤스는 마이클 센델이 주장하는 공동체주의와 유사하면서도 매우 다르다. 두 사람 모두 정의로운 사회를 위해 어떻게 나아가야 하는가에 대해서 관점을 제시하지만, 센델은 개인의 정체성은 가족, 지역사회, 국가 등의 공동체로부터 출발하고, 공동체의 일원이기 때문에 갖게 되는 도덕적 의무가 중요하다라고 주장한다. 그에 반해 롤스는 공동체의 의무보다는 개인의 자유와 평등에 초점을 맞추고, 내가 가진 모든 특성과 환경은 그저 운에 따르기 때문에, 개인이 부자인지 가난한지, 어떤 재능을 가졌는지 아예 모르는 상태(무지의 베일)에서 사회 규칙에 대해 합의하는 것이 진정한 정의라고 말한다. 특히나 ‘정의’가 ‘선’이나 ‘도덕’보다 우선한다는 것에서 센델과 차이가 있다고 느꼈다. <br/><br/>

                롤스는 불평등은 특정한 상황에서만 허용되어야 한다고 하는데, 사회에서 가장 혜택받지 못하는 사람(최소 수혜자)에게 최대의 이익이 될 수 있을 때, 불평등한 지위나 직책에 접근할 기회가 <b>모든 사람에게 실질적으로 평등하게 개방될 수 있다면 불평등이 허용될 수 있다고 주장했다.</b> 절차가 공정하면 그 결과도 공정하다라고 보는 입장에서 공산주의와의 견해가 다르다. <br/><br/>

                롤스의 정치 철학은 최대 다수의 최대 행복을 주장하는 공리주의의에서 소수가 희생하게 되는 한계를 극복할 수 있다는 점에서 사회적 약자를 배려하는 방향의 국가의 방향을 제시하고 있다. 하지만 이 관점은 열심히 일한 사람의 노력을 인정하지 않아 사회 전체가 발전에 있어 무기력해질 수 있고, 개인의 노력이 인정받지 못해 부당함을 느낄 수 있다는 한계도 갖고 있다고 생각한다. <br/>

                다만, 가장 공감이 되는 것은 개인은 노력에 앞서 모든 환경과 주어진 상황은 운에 따라 결정되며, 그 의지와 정체성도 운에 따라 달라질 수 있음이며, 그러한 운이 삶의 전망을 결정하지 않도록 보정하는 시스템을 마련한다는 관점에서 지지하고 싶은 견해였다.<br/><br/>

                <QuoteBlock>모두가 평등한 자유를 누리고, 노력에 따른 불평등은 인정하되, 그 불평등이 사회적 약자에게도 도움이 되어야 정의로운 사회다.  </QuoteBlock>라는 정의는 비판 없이 받아들일만 하다.<br/> <br/> 

                다만 여전히 센델이 비판한 것과 같이 인간은 공동체를 통해 정의될 수 있으며, 공동체가 없는 개인은 존재할 수 없다라는 관점에 좀더 공감이 된다. 공동체를 이루기 위한 기여와 책임은 마땅히 주어져야 하며, 또한 정의라는 것은 선과 도덕보다 우선할 수 있는가에 대해서는 여전히 의문이 남는다.
                            
                </div>}
          />
            <CalloutLink href="https://product.kyobobook.co.kr/detail/S000216453083" target="_blank">
                롤스 정의론 - 어떤 자유주의가 정의로운가  |  김유찬 
                </CalloutLink>
          <NextItem to='/book2' nextProjectTitle='우리가 빛의 속도로 갈 수 없다면'/>

          <BackButton/>
          {/* </ProtectedPage> */}
        </div>
        </>
      )
  }
  
  export default Book1;